import View from 'views/base/view';
import AlertTemplate from './templates/alert';
import AudioStarterAlertTemplate from './templates/audio-starter-alert';
import Chaplin from 'chaplin';
import IconLoadService from 'services/loader-handler-services/icon-load-service';

/*
Use:
  this.renderAlert(
    'error', << alert type will add this to the alert container as a class for style overrides
    'alert title',
    'alert body text. For accessibility, include an id in the text and be clear what the user is to do for next steps',
    'alert-icon fas icon-for-alert'  << icon class name
    );
*/

export const AlertView = View.extend({
  template: AlertTemplate,
  autoRender: true,
  className: 'content__container',
  attach: function () {
    const icon = this.model?.get('ico');
    if (icon) {
      IconLoadService.applyIcon(icon, `${this.model?.get('type')}__alert__icon`);
    }
    this.timeoutId = setTimeout(
      () => {
        Chaplin.mediator.publish('alert:close');
      },
      this.model?.has('timeout') ? this.model.get('timeout') : 5000
    );
    View.prototype.attach.apply(this, arguments);
  },
});

export const AudioStarterAlertView = View.extend({
  template: AudioStarterAlertTemplate,
  autoRender: true,
  region: 'audio-starter-alert',
  className: 'content__container',
  attach: function () {
    IconLoadService.applyIcon('fas fa-exclamation-circle', 'audio-starter__icon');
    this.delegate('click', '.alert__closeBtn, #start_audio', function () {
      Chaplin.mediator.publish('audio:unblock');
      Chaplin.mediator.publish('audio-starter-alert:close');
    });
    View.prototype.attach.apply(this, arguments);
  },
});
